import bgImage from "../../image/signin2.svg";

import { build_color_palette } from "./colors";
import { emConverter, fontSizeWeight } from "./style-util";

const palette_config = {
  //Product
  "Primary Color": "blue-6",
  "Primary Color Hover": "blue-5",
  "Primary Color Pressed/Active": "blue-7",
  "Primary Color Background Hover": "blue-1",
  "Primary Color Border Color": "blue-3",
  //Neutral
  Title: "grey-9",
  "Primary text": "grey-8",
  "Secondary text": "grey-7",
  Disable: "grey-6",
  Border: "grey-5",
  Dividers: "grey-4",
  Background: "grey-3",
  "Table header": "grey-2",
  "Inverse Primary text": "grey-1",
  "Inverse Secondary text": "grey-2",
  //Alert
  "Info Primary": "blue-6",
  "Info Primary Hover": "blue-5",
  "Info Border": "blue-3",
  "Info Background": "blue-1",
  "Success Primary": "green-6",
  "Success Primary Hover": "green-5",
  "Success Border": "green-3",
  "Success Background": "green-1",
  "Warning Primary": "gold-6",
  "Warning Primary Hover": "gold-5",
  "Warning Border": "gold-3",
  "Warning Background": "gold-1",
  "Error Primary": "red-6",
  "Error Primary Hover": "red-5",
  "Error Border": "red-3",
  "Error Background": "red-1",
  //Splash Screen
  "Splash Background": "grey-3",
  "Splash Footer Text": "grey-6",
};

const palette = build_color_palette(palette_config);
const text = fontSizeWeight();
const chartColors = {
  red: ["#EF1A11", "#470705"],
  blue: ["#4D7A99", "#99C0FF"],
  green: ["#008000", "#90EE90"],
  grey: ["#808080", "#DCDCDC"],
  gold: ["#FFD700", "#EEE8AA"],
  investment_mix: ["#4D7A99", "#99C0FF"],
  account_values: ["#4D7A99", "#99C0FF"],
};

const theme = {
  font: "Assistant",
  fontMonospace: "Consolas, Liberation Mono, Menlo, Courier, monospace",

  panelLogo: "siteLogoDark",
  panelBG: bgImage,

  headerColor: "#000",
  headerText: palette["Inverse Primary text"],
  headerSelectedText: palette["grey"]["grey-7"],
  topbarColor: "#FFF",
  topbarText: palette["Primary text"],
  sidebarLogo: "siteLogo",
  sidebarIcon: "siteIcon",
  sidebarTheme: "dark",
  topmenuLogo: "siteLogo",
  topmenuIcon: "siteIcon",
  topmenuTheme: "light",
  splashLogo: "siteLogoDark",

  chart: chartColors,

  color: palette,
  text: text,
  emConverter: emConverter,
};

export default theme;
